<!--page starts-->
<section class="page-wrapper">
	<div class="ashton-hero-top">
		<div class="ashton-hero-mouse"><a href="javascript:void(0)"><img src="assets/images/mouse.svg" alt="mouse"></a>
		</div>
		<div class="leicester-main-section margin-top-152 cf">
			<div class="container">
				<div class="leicester-detail margin-top-30 cf ">
					<div class="leicester-detail-top cf">
						<!-- <div class="header-top-menu-left-menu-list mobile-list">
	                        <ul>
	                          <li><a routerLink="/buytickets">Buy Tickets</a></li>
	                          <li><a routerLink="/sessiontickets">Season Tickets</a></li>
	                          <li><a routerLink="/clubsponsorship">Club Sponsorship</a></li>
	                          <li><a routerLink="/shop">Merchandise</a></li>
	                          <li><a routerLink="/matchday">Match Day Hospitality</a></li>
	                        </ul>
	                    </div> -->
						<div class="leicester-detail-left">
							<h2 *ngIf="bannerList?.title">{{bannerList?.title}} </h2>
							<p *ngIf="bannerList?.subtitle">{{bannerList?.subtitle}}</p>
						</div>
						<div class="leicester-detail-right" *ngIf="livematcheList?.data?.length > 0">
							<h4>{{livematchesList?.first_name}} vs {{livematchesList?.second_name}}</h4>
						
							<div class="leicester-right-match-box">
								<div class="leicester-right-match-box-inner-top">
									<div class="leicester-right-match-box-inner-top-inner">
										<div class="leicester-right-match-box-main ">
											<div class="leicester-team-logo-box">
												<div class="leicester-team-logo-image" *ngIf="livematchesList?.first_image">
													<img [src]="livematchesList?.first_image">
												</div>
												
											</div>
											<!-- <div class="leicester-team-score-right">
												<h4>301 & 272/7d</h4>
											</div> -->
										</div>
									
										<div class="leicester-right-match-box-main-vs">
										<h3>vs</h3>
										</div>
										<div class="leicester-right-match-box-main">
											<div class="leicester-team-logo-box">
												<div class="leicester-team-logo-image" *ngIf="livematchesList?.second_image">
													<img [src]="livematchesList?.second_image">
												</div>
												<!-- <div class="leicester-team-logo-score">
													<p>(80.3 ov, target 237)</p>
												</div> -->
											</div>
											<!-- <div class="leicester-team-score-right">
												<h4>301 & 272/7d</h4>
											</div> -->
										</div>
									</div>
									<div class="leicester-team-logo-score-content">
										<p>{{livematchesList?.series_catagory_title}}</p>
									</div>
								</div>
								<div class="match-report-btn">
									<div class="match-report-btn-inner">
										<a [routerLink]="['/livescore', livematchesList?.matchid]" *ngIf="livematchesList?.matchid">Watch Now</a>
									</div>
								</div>
							</div>
						</div>
						<div class="leicester-detail-right" *ngIf="livematcheListWomen?.data?.length > 0">
							<h4>{{livematchesListWomen?.first_name}} vs {{livematchesListWomen?.second_name}}</h4>
						
							<div class="leicester-right-match-box">
								<div class="leicester-right-match-box-inner-top">
									<div class="leicester-right-match-box-inner-top-inner">
										<div class="leicester-right-match-box-main ">
											<div class="leicester-team-logo-box">
												<div class="leicester-team-logo-image" *ngIf="livematchesListWomen?.first_image">
													<img [src]="livematchesListWomen?.first_image">
												</div>
												
											</div>
											<!-- <div class="leicester-team-score-right">
												<h4>301 & 272/7d</h4>
											</div> -->
										</div>
									
										<div class="leicester-right-match-box-main-vs">
										<h3>vs</h3>
										</div>
										<div class="leicester-right-match-box-main">
											<div class="leicester-team-logo-box">
												<div class="leicester-team-logo-image" *ngIf="livematchesListWomen?.second_image">
													<img [src]="livematchesListWomen?.second_image">
												</div>
												<!-- <div class="leicester-team-logo-score">
													<p>(80.3 ov, target 237)</p>
												</div> -->
											</div>
											<!-- <div class="leicester-team-score-right">
												<h4>301 & 272/7d</h4>
											</div> -->
										</div>
									</div>
									<div class="leicester-team-logo-score-content">
										<p>{{livematchesListWomen?.series_catagory_title}}</p>
									</div>
								</div>
								<div class="match-report-btn">
									<div class="match-report-btn-inner">
										<a routerLink="/womens-fixture">Watch Now</a>
									</div>
								</div>
							</div>
						</div>
					</div>
					
					<div class="leicester-detail-bottom cf">
						<div class="leicester-detail-bottom-inner">
							<div class="leicester-detail-bottom-inner-tab">
								<ul>
									<!-- <li class="match-name  active" id="upcoming-matches"><a href="#">Upcoming Matches</a>
									</li> -->
									<!-- <li class="match-name " id="bob-willis"><a href="#">Bob Willis Trophy</a></li> -->
								</ul>
								<div class="leicester-detail-bottom-inner-see-all">
									<!-- <a routerLink="/fixtures">View All</a> -->
								</div>
							</div>
							<div class="leicester-match-section match-main-content active"
								id="upcoming-matches-content">
								<div class="leicester-match-section-inner">
									<ngx-slick-carousel class="carousel" slickModal="slick-carousel"
										[config]="slidematchConfig">
										<div ngxSlickItem class="leicester-match-box slide"
											*ngFor="let upcoming of upcomingmatchesList?.data">
											<div class="leicester-match-box-left">
												<div class="leicester-match-box-left-logo-box">
													<div class="leicester-match-left">
														<img [src]="upcoming?.first_image">
													</div>
													<div class="leicester-match-center">
														<h2>vs</h2>
													</div>
													<div class="leicester-match-right">
														<img [src]="upcoming?.second_image">
													</div>
												</div>
												<div class="leicester-match-box-left-content">
													<div class="leicester-match-box-right-btn" >
														<a href="{{upcoming?.redirect_url}}" *ngIf="upcoming?.redirect_url && upcoming?.is_sold_out =='No'" target="_blank">Book Tickets</a>
														<a *ngIf="upcoming?.is_sold_out =='Yes'" disabled class="grey">SOLD OUT</a>
													</div>
													<!-- <h4>{{upcoming?.location}}</h4>
													<p>{{upcoming?.date_time | amDateFormat: "DD MMM YYYY,"}} Starts
														{{upcoming?.date_time | amDateFormat: "HH:mm"}}</p> -->
												</div>
											</div>
											<div class="leicester-match-box-right">
												<!-- <div class="leicester-match-box-right-btn" >
													<a href="{{upcoming?.redirect_url}}" *ngIf="upcoming?.redirect_url && upcoming?.is_sold_out =='No'" target="_blank">Book Tickets</a>
													<a *ngIf="upcoming?.is_sold_out =='Yes'" disabled class="grey">SOLD OUT</a>
												</div> -->
												<div class="leicester-match-box-right-top">
													<div class="leicester-match-box-right-team-name">
														<h3>{{upcoming?.first_name}}</h3>
													</div>
													<div class="leicester-match-box-right-team-vs">
														<h3>vs</h3>
													</div>
													<div class="leicester-match-box-right-team-name">
														<h3>{{upcoming?.second_name}}</h3>
													</div>
												</div>
												<div class="leicester-match-box-right-bottom">
													<h4>{{upcoming?.location}}</h4>
													<p>{{upcoming?.date_time | amDateFormat: "DD MMM YYYY,"}} Starts
															{{upcoming?.date_time | amDateFormat: "HH:mm"}}</p>
												</div>
											</div>
										</div>

									</ngx-slick-carousel>
								</div>
							</div>
							<div class="leicester-match-section match-main-content " id="bob-willis-content">
								<div class="leicester-match-section-inner">
									<ngx-slick-carousel class="carousel" slickModal="slick-carousel"
										[config]="slidematchtwoConfig">
										<div ngxSlickItem class="leicester-match-box slide"
											*ngFor="let past of pastmatchesList?.data">
											<div class="leicester-match-box-left">
												<div class="leicester-match-box-left-logo-box">
													<div class="leicester-match-left">
														<img [src]="past?.first_image">
													</div>
													<div class="leicester-match-center">
														<h2>vs</h2>
													</div>
													<div class="leicester-match-right">
														<img [src]="past?.second_image">
													</div>
												</div>
												<div class="leicester-match-box-left-content">
													<div class="leicester-match-box-right-btn">
														<a routerlink="/tickets">Book Tickets</a>
													</div>
													<!-- <h4>{{past?.location}}</h4>
													<p>{{past?.date_time | amDateFormat: "DD MMM YYYY,"}} Starts
														{{past?.date_time | amDateFormat: "HH:mm"}}</p> -->
												</div>
											</div>
											<div class="leicester-match-box-right">
												<!-- <div class="leicester-match-box-right-btn">
													<a routerlink="/tickets">Book Tickets</a>
												</div> -->
												<div class="leicester-match-box-right-top">
													<div class="leicester-match-box-right-team-name">
														<h3>{{past?.first_name}}</h3>
													</div>
													<div class="leicester-match-box-right-team-vs">
														<h3>vs</h3>
													</div>
													<div class="leicester-match-box-right-team-name">
														<h3>{{past?.second_name}}</h3>
													</div>
												</div>
												<div class="leicester-match-box-right-bottom">
													<h4>{{past?.location}}</h4>
													<p>{{past?.date_time | amDateFormat: "DD MMM YYYY,"}} Starts
															{{past?.date_time | amDateFormat: "HH:mm"}}</p>
												</div>
											</div>
										</div>
									</ngx-slick-carousel>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
		<div class="header-left-social-icon dsk">
			<ul>
				<li><a href="https://www.facebook.com/leicsccc" target="_blank"><img src="assets/images/fb.svg"alt="fb"></a></li>
				<li><a href="https://instagram.com/leicsccc" target="_blank"><img src="assets/images/insta.svg"	alt="insta"></a></li>
				<li><a href="https://www.youtube.com/user/leicestershireccc1/videos" target="_blank"><img src="assets/images/youtube.svg" alt="youtube"></a></li>
				<li><a href="http://www.twitter.com/leicsccc" target="_blank"><img src="assets/images/twi.svg"alt="twi"></a></li>
				<li><a href="https://www.tiktok.com/@leicsccc" target="_blank" class="tiktok"><img src="assets/images/tik-tok.svg" alt="tik-tok"></a></li>
			</ul>
		</div>
		<div class="ashton-hero-top-overlay"></div>
		<div class="ashton-hero-top-slider">
			<ngx-slick-carousel class="carousel" slickModal="slick-carousel" [config]="slidehomebannerConfig">
				<div ngxSlickItem class="ashton-hero-top-slider-box-main slide" *ngFor="let banner of bannerList?.data">
					<a href="{{banner?.url}}" target="_blank">
						<div   class="ashton-hero-top-slider-box " [ngStyle]="{'background-image':'url(' + banner?.file + ')'}">
						</div>
					</a>
				</div>
				<!-- <div ngxSlickItem class="ashton-hero-top-slider-box-main slide">
					<div class="ashton-hero-top-slider-box " [ngStyle]="{'background-image':'url(' + bannerList?.file + ')'}">
					</div>
				</div> -->
			</ngx-slick-carousel>
		</div>
	</div>
	<div class="add-detail-section cf">
		<div class="add-right-section">
		   <!---->
		   <div class="live-score-right-bottom">
			  <!---->
			  <div class="live-score-right-bottom-box" *ngFor="let banner of adbannerList?.data">
				  <a href="{{banner?.url}}" target="{{banner?.btn_type}}" ><img [src]="banner?.file" alt="{{banner?.title}}"></a>
			</div>
			  <!--<div class="live-score-right-bottom-box"><a href="https://www.eticketing.co.uk/leicestershireccc/Memberships/Details/Index/8" target="_blank" ><img src="assets/images/vitality.jpeg" alt="add-offer-top-img1"></a></div>
			  <div class="live-score-right-bottom-box"><a routerLink="/membership" ><img src="assets/images/add-offer-top-img2.png" alt="add-offer-top-img2"></a></div>
			  <div class="live-score-right-bottom-box"><a routerLink="/event/whats-on/concerts" ><img src="assets/images/add-offer-top-img3.png" alt="add-offer-top-img3"></a></div>-->
		   </div>
		</div>
	 </div>
	<div class="latest-new-section cf">
		<div class="container">
			<div class="latest-new-detail-section">
				<div class="titel-box">
					<h2 class="titel-name">Latest News</h2>
					<a routerLink="/news"><span>See All</span></a>
				</div>
				<div class="latest-new-detail cf">
					<ngx-slick-carousel class="carousel" slickModal="slick-carousel" [config]="slidenewConfig">
						<div ngxSlickItem class="latest-new-box slide" *ngFor="let news of newsList?.data">
							<a [routerLink]="['/news', news?.slug]">
								<div class="latest-new-image">
									<img [src]="news?.thumbnail_image">
								</div>
								<div class="latest-new-content">
									<h4>{{news?.date | amDateFormat: "DD MMMM YYYY"}}</h4>
									<p>{{news?.title}}</p>
								</div>
							</a>
						</div>

					</ngx-slick-carousel>
				</div>
			</div>
			<div class="grace-road-section top-section cf" >
				<div class="container">
					<div class="grace-road-detail" >
						<div class="grace-road-content" [ngStyle]="{'background-image':'url(' + evnetList?.data?.image + ')'}">
							<div class="grace-road-event-btn"><a href="https://www.eticketing.co.uk/leicestershireccc" target="_blank">{{evnetList?.data?.title}}</a></div>
							<p *ngIf="evnetList?.data?.subtitle">{{evnetList?.data?.subtitle}}</p>
							<div class="grace-road-know-more"><a routerLink="/tickets">Buy Now</a></div>
						</div>
						<div class="grace-road-image-detail">
							<ngx-slick-carousel class="carousel" slickModal="slick-carousel" [config]="slidegraceConfig" >
								<div ngxSlickItem class="grace-road-image-box slide"  *ngFor="let detail of cricketsList?.data">
									<a href="{{detail?.btn_url_1}}" target="_blank"><img [src]="detail?.image"></a>
								</div>
							</ngx-slick-carousel>
						</div>
					</div>
				</div>
			</div>
			<div class="latest-video-detail cf" *ngIf="videoList">
				<div class="titel-box">
					<h2 class="titel-name">Foxes TV</h2>
					<a routerLink="/videos"><span>See All</span></a>
				</div>
				<div class="latest-new-detail cf">
					<ngx-slick-carousel class="carousel" slickModal="slick-carousel" [config]="slidevideoConfig">
						<div ngxSlickItem class="video-slider slide">
							<div class="latest-video-box "
								*ngFor="let video of videoList?.data| slice:0:6; let i = index ">
								<div class="latest-video-box-top ">

									<div class="latest-new-image">
										<img [src]="video?.thumbnail_image">
									</div>
									<div class="latest-new-image-hover">
										<img [src]="video?.image">
									</div>
									<div class="video-overlay">
										<div class="video-paly-icon">
											<a href="{{video?.video}}" class="popup-youtube">
												<img src="assets/images/play-button.png">
											</a>
										</div>
										<div class="video-overlay-content">
											<div class="video-overlay-text">
												<p>{{video?.title}}</p>
											</div>
										</div>
									</div>

								</div>
							</div>
						</div>
						<div ngxSlickItem class="video-slider slide">
							<div class="latest-video-box "
								*ngFor="let video of videoList?.data| slice:6:12; let i = index">
								<div class="latest-video-box-top ">

									<div class="latest-new-image">
										<img [src]="video?.thumbnail_image">
									</div>
									<div class="latest-new-image-hover">
										<img [src]="video?.image">
									</div>
									<div class="video-overlay">
										<div class="video-paly-icon">
											<a href="{{video?.video}}" class="popup-youtube">
												<img src="assets/images/play-button.png">
											</a>
										</div>
										<div class="video-overlay-content">
											<div class="video-overlay-text">
												<p>{{video?.title}}</p>
											</div>
										</div>
									</div>

								</div>
							</div>
						</div>
					</ngx-slick-carousel>
				</div>
				<div class="latest-new-detail mobile cf">
					<ngx-slick-carousel class="carousel" slickModal="slick-carousel" [config]="slidevideoConfig">
						<div ngxSlickItem class="video-slider slide" *ngFor="let video of videoList?.data; let i = index ">
							<div class="latest-video-box">
								<div class="latest-video-box-top ">

									<div class="latest-new-image">
										<img [src]="video?.thumbnail_image">
									</div>
									<div class="latest-new-image-hover">
										<img [src]="video?.image">
									</div>
									<div class="video-overlay">
										<div class="video-paly-icon">
											<a href="assets/images/videoplayback.mp4" class="popup-youtube">
												<img src="assets/images/play-button.png">
											</a>
										</div>
										<div class="video-overlay-content">
											<div class="video-overlay-text">
												<p>{{video?.title}}</p>
											</div>
										</div>
									</div>
								</div>
							</div>
						</div>
					</ngx-slick-carousel>
				</div>
			</div>
		</div>
	</div>

	<!-- <div class="vector-section cf">
		<div class="vector-detail" >
			<video loop muted controls="true"  onloadedmetadata="this.muted = true"
				id="video" class="banner__background-video" *ngIf="homevideoList?.type == 'Video'">
				<source src="{{homevideoList?.file}}" type="video/mp4">
			</video>
			<div class="vector-overlay" id="box">
				<div class="vector-overlay-inner">
					<img src="assets/images/fox-transparent-new.png">
				</div>
			</div>
		</div>
	</div> -->
	<div class="grace-road-section cf" *ngIf="evnetsecList">
		<div class="container">
			<!-- <div class="grace-road-detail" *ngIf="evnetList">
				<div class="grace-road-content" [ngStyle]="{'background-image':'url(' + evnetList?.data?.image + ')'}">
					<div class="grace-road-event-btn"><a [routerLink]="['/event', evnetList?.data?.slug]">{{evnetList?.data?.title}}</a></div>
					<p *ngIf="evnetList?.data?.subtitle">{{evnetList?.data?.subtitle}}</p>
					<div class="grace-road-know-more"><a [routerLink]="['/event', evnetList?.data?.slug]">Know More</a></div>
				</div>
				<div class="grace-road-image-detail">
					<ngx-slick-carousel class="carousel" slickModal="slick-carousel" [config]="slidegraceConfig">
						<div ngxSlickItem class="grace-road-image-box slide" *ngFor="let events of evnetList?.data?.event">
							<a [routerLink]="['/event', evnetList?.data?.slug]"><img [src]="events?.image"></a>
						</div>
					</ngx-slick-carousel>
				</div>
			</div> -->
			<!-- <div class="grace-road-detail" *ngIf="evnetsecList" >
				<div class="grace-road-content" [ngStyle]="{'background-image':'url(' + evnetsecList?.data?.image + ')'}">
					<div class="grace-road-event-btn"><a [routerLink]="['/event', evnetsecList?.data?.slug]">{{evnetsecList?.data?.title}}</a></div>
					<p *ngIf="evnetsecList?.data?.subtitle">{{evnetsecList?.data?.subtitle}}</p>
					<div class="grace-road-know-more"><a [routerLink]="['/event', evnetsecList?.data?.slug]">Know More</a></div>
				</div>
				<div class="grace-road-image-detail">
					<ngx-slick-carousel class="carousel" slickModal="slick-carousel" [config]="slidegraceConfig">
						<div ngxSlickItem class="grace-road-image-box slide" *ngFor="let events of evnetsecList?.data?.event">
							<a [routerLink]="['/event', evnetsecList?.data?.slug]"><img [src]="events?.image"></a>
						</div>

					</ngx-slick-carousel>
				</div>
			</div> -->
		</div>
	</div>
	<div class="player-staff-section cf">
		<div class="player-staff-titel">
			<div class="container">
				<div class="titel-box">
					<h2 class="titel-name">PLAYERS & STAFF</h2>
				</div>
			</div>
		</div>
		<div class="player-staff-section-inner cf">
			<div class="player-staff-bg"></div>
			<div class="container">
				<div class="player-staff-detail cf">
					<div class="player-staff-tab">
						<ul class="stafftab">
							<li class="player-name active "  id="Men"><a id="Men" href="javascript:void(0)">First Team</a></li>
							<li class="player-name "   id="Women"><a  id="Women" href="javascript:void(0)">Women's Team</a></li>
							<li class="player-name "   id="Academy"><a id="Academy" href="javascript:void(0)">Academy</a></li>
							<li class="player-name "  id="Coaching_Staff"><a id="Coaching_Staff" href="javascript:void(0)">Coaching Staff</a></li>
						</ul>
					</div>
					
					<div class="player-staff-tab-detail player-main-content " id="Coaching_Staff-content">
						<div class="player-staff-tab-detail-see-all" *ngIf="playerCoachingList?.data?.length > 0">
							<a routerLink="/player">See All</a>
						</div>
						<div class="player-staff-detail-box cf" *ngIf="playerCoachingList?.data?.length > 0">
							<ngx-slick-carousel class="carousel" slickModal="slick-carousel" [config]="slideplayerxiConfig">
								<div ngxSlickItem class="player-staff-box slide"
									*ngFor="let coaching of playerCoachingList?.data | slice: 0:6; let i = index ">
									<a [routerLink]="['/player-single', coaching?.slug]">
										<img [src]="coaching?.image">
										<div class="player-staff-box-overlay">
											<p>{{coaching?.first_name}}</p>
											<h4>{{coaching?.last_name}}</h4>
										</div>
										
									</a>
								</div>

							</ngx-slick-carousel>
						</div>
					</div>
					<div class="player-staff-tab-detail player-main-content active" id="Men-content">
						<div class="player-staff-tab-detail-see-all" *ngIf="playerManList?.data?.length > 0">
							<a routerLink="/player">See All</a>
						</div>
						<div class="player-staff-detail-box cf" *ngIf="playerManList?.data?.length > 0">
							<ngx-slick-carousel class="carousel" slickModal="slick-carousel"
								[config]="slideplayerxiConfig">
								<div ngxSlickItem class="player-staff-box slide"
									*ngFor="let man of playerManList?.data | slice: 0:6; let i = index">
									<a [routerLink]="['/player-single', man?.slug]">
										<img [src]="man?.image">
										<div class="player-staff-box-overlay">
											<p>{{man?.first_name}}</p>
											<h4>{{man?.last_name}}</h4>
										</div>
										<div class="player-staff-overlay-number">
											<h3>{{man?.players_number}}</h3>
										</div>
									</a>
								</div>

							</ngx-slick-carousel>
						</div>
					</div>
					<div class="player-staff-tab-detail player-main-content " id="Academy-content">
						<div class="player-staff-tab-detail-see-all" *ngIf="playerAcademyList?.data?.length > 0">
							<a routerLink="/player">See All</a>
						</div>
						<div class="player-staff-detail-box cf" *ngIf="playerAcademyList?.data?.length > 0">
							<ngx-slick-carousel class="carousel" slickModal="slick-carousel"
								[config]="slideplayerxiConfig">
								<div ngxSlickItem class="player-staff-box slide"
									*ngFor="let academy of playerAcademyList?.data | slice: 0:6; let i = index">
									<a [routerLink]="['/player-single', academy?.slug]">
										<img [src]="academy?.image">
										<div class="player-staff-box-overlay">
											<p>{{academy?.first_name}}</p>
											<h4>{{academy?.last_name}}</h4>
										</div>
										
									</a>
								</div>

							</ngx-slick-carousel>
						</div>
					</div>
					<div class="player-staff-tab-detail player-main-content " id="Women-content">
						<div class="player-staff-tab-detail-see-all" *ngIf="playerWomenList?.data?.length > 0">
							<a routerLink="/player">See All</a>
						</div>
						<div class="player-staff-detail-box cf" *ngIf="playerWomenList?.data?.length > 0">
							<ngx-slick-carousel class="carousel" slickModal="slick-carousel"
								[config]="slideplayerxiConfig">
								<div ngxSlickItem class="player-staff-box slide"
									*ngFor="let woman of playerWomenList?.data | slice: 0:6; let i = index">
									<a href="javascript:void(0)">
										<img [src]="woman?.image">
										<!-- <div class="player-staff-box-overlay">
											<p>{{woman?.first_name}}</p>
											<h4>{{woman?.last_name}}</h4>
										</div> -->
										
									</a>
								</div>

							</ngx-slick-carousel>
						</div>
					</div>
				</div>
				<div class="fixtures-section cf">
					<div class="titel-box">
						<h2 class="titel-name">FIXTURES & RESULTS</h2>
					</div>
					<div class="fixtures-detail cf">
						<div class="fixture-season-tab-detail">
							<ul class="maintab">
								<li class="courses-name" [ngClass]="{ active: i == 1 }" id="tab-{{maincat?.series_type_id}}"
									*ngFor="let maincat of matchesnewList?.data; let i = index"><a
										href="javascript:void(0)">{{maincat?.title}}</a></li>								
							</ul>
						</div>
						<div class="fixture-season-tab-content-detail course-main-content cf " [ngClass]="{ active: i == 1 }"
							id="tab-{{maincat?.series_type_id}}-content"
							*ngFor="let maincat of matchesnewList?.data; let i = index">
							<div class="fixture-season-tab-inner">
								<div class="container">
									<div class="fixture-season-tab-inner-detail">
										<ul class="maintab-inner">
											<li class="inner-name" [ngClass]="{ active: i == 0 }"
												id="subtab-{{subcat?.series_catagory_id}}"
												*ngFor="let subcat of maincat?.series_catagory; let i = index"><a
													href="javascript:void(0)">{{subcat?.title}}</a></li>											
										</ul>
									</div>
									<div class="fixture-season-tab-inner-detail-content inner-main-content"
										[ngClass]="{ active: i == 0 }" id="subtab-{{subcat?.series_catagory_id}}-content"
										*ngFor="let subcat of maincat?.series_catagory; let i = index">
										<div class="container">
											<div class="fixture-season-tab-content-top">
												<div class="fixture-season-tab-celender">

												</div>
												<div class="fixture-season-tab-matches">
													<div class="second-fixtures-detail-tab">
														<div class="second-fixtures-detail-tab-list">
															<ul class="subtab">
																<li class="fixtures-name ok"
																	id="upcoming-{{subcat?.series_catagory_id}}"><a href="#"
																		id="Upcoming">Upcoming Matches</a></li>
																<li class="fixtures-name " id="past-{{subcat?.series_catagory_id}}">
																	<a href="#" id="Past">Past Matches</a></li>
															</ul>
														</div>
													</div>
													<div class="second-fixtures-detail-tab-detail fixtures-main-content ok"
														id="upcoming-{{subcat?.series_catagory_id}}-content">
														<div class="leicester-match-section cf">
															<ngx-slick-carousel class="carousel" slickModal="slick-carousel"
																[config]="slidematchbookConfig">
																<div ngxSlickItem class="leicester-match-box-slide slide cf"
																	*ngFor="let upcoming of subcat?.upcoming_match">
																	<div class="leicester-match-box" [ngStyle]="{'background-image':'url(' + upcoming?.image + ')'}">
																		<div class="leicester-match-box-left">
																			<div class="leicester-match-box-left-logo-box">
																				<div class="leicester-match-left"><img
																						[src]="upcoming?.first_image"></div>
																				<div class="leicester-match-center">
																					<h2>vs</h2>
																				</div>
																				<div class="leicester-match-right"><img
																						[src]="upcoming?.second_image"></div>
																			</div>
																			<div class="leicester-match-box-left-content">
																				<h4>{{upcoming?.location}}</h4>
																				<p>{{upcoming?.date_time | amDateFormat: "DD MMM
																					YYYY,"}} Starts {{upcoming?.date_time |
																					amDateFormat: "HH:mm"}}</p>
																			</div>
																		</div>
																		<div class="leicester-match-box-right">
																			<div class="leicester-match-box-right-btn">
																				<a href="{{upcoming?.redirect_url}}" tabindex="-1" *ngIf="upcoming?.redirect_url && upcoming?.is_sold_out == 'No'" target="_blank">Book
																					Tickets</a>
																					<a *ngIf="upcoming?.is_sold_out == 'Yes'" disabled class="grey">SOLD OUT</a>
																			</div>
																		</div>
																		<div class="leicester-match-overlay"></div>
																	</div>
																</div>															
															</ngx-slick-carousel>
														</div>
													</div>
													<div class="second-fixtures-detail-tab-detail fixtures-main-content "
														id="past-{{subcat?.series_catagory_id}}-content">
														<div class="leicester-match-section cf">
															<ngx-slick-carousel class="carousel" slickModal="slick-carousel"
																[config]="slidematchreportConfig">
																<div ngxSlickItem class="leicester-match-box-slide slide cf"
																	*ngFor="let past of subcat?.past_match">
																	<div class="leicester-match-box" [ngStyle]="{'background-image':'url(' + past?.image + ')'}">
																		<div class="leicester-match-box-left">
																			<div class="leicester-match-box-left-logo-box">
																				<div class="leicester-match-left"><img
																						[src]="past?.first_image"></div>
																				<div class="leicester-match-center">
																					<h2>vs</h2>
																				</div>
																				<div class="leicester-match-right"><img
																						[src]="past?.second_image"></div>
																			</div>
																			<div class="leicester-match-box-left-content">
																				<h4>{{past?.location}}</h4>
																				<p>{{past?.date_time | amDateFormat: "DD MMM
																					YYYY,"}} Starts {{past?.date_time |
																					amDateFormat: "HH:mm"}}</p>
																			</div>
																		</div>
																		<div class="leicester-match-box-right">
																			<div class="leicester-match-box-right-btn"><a
																					href="{{past?.redirect_url}}" tabindex="-1" *ngIf="past?.redirect_url && past?.is_sold_out == 'No'" target="_blank">Book
																					Tickets</a>
																					<a *ngIf="past?.is_sold_out == 'Yes'" disabled class="grey">SOLD OUT</a>
																				</div>
																		</div>
																		<div class="leicester-match-overlay"></div>
																	</div>
																</div>															
															</ngx-slick-carousel>
														</div>
													</div>
												</div>
											</div>											
										</div>
									</div>
									
								</div>
							</div>
			
						</div>
						
					</div>
				</div>
			</div>
		</div>
		<div class="grace-road-section membership-section cf">
			<div class="membership-bg"></div>
			<div class="container">
				<div class="grace-road-detail">
					<div class="grace-road-content"
						[ngStyle]="{'background-image':'url(' + membershipList?.general?.image + ')'}">
						<div class="grace-road-event-btn"><a href="#">{{membershipList?.general?.title}}</a></div>
						<p>{{membershipList?.general?.subtitle}}</p>
						<div class="grace-road-know-more"><a routerLink="/membership">Know More</a></div>
					</div>
					<!-- <div class="grace-road-image-detail">
						<ngx-slick-carousel class="carousel" slickModal="slick-carousel" [config]="slidegraceConfig">
							<div ngxSlickItem class="grace-road-image-box slide"
								*ngFor="let membership of membershipList?.data">
								<img [src]="membership?.image">
							</div>
							<div ngxSlickItem class="grace-road-image-box slide">
								<img src="assets/images/header3.jpg">
							</div> 
						</ngx-slick-carousel>
					</div> -->
				</div>
			</div>
		</div>
		<!-- <div class="shop-section cf" [ngStyle]="{'background-image':'url(' + bannerbottomList?.file + ')'}">
			<div class="container">
				<div class="shop-detail">
					<div class="shop-btn">
						<a routerLink="/shop">Shop Now</a>
					</div>
				</div>
			</div>
		</div> -->
		<!-- <div class="our-partner-section cf">
			<div class="our-partner-titel">
				<div class="container">
					<div class="titel-box">
						<h2 class="titel-name">OUR PARTNERS</h2>
					</div>
				</div>
			</div>
			<div class="our-partner-detail cf">
				<div class="our-partner-bg"></div>
				<div class="container">
					<div class="our-partner-detail-hero">
						<div class="our-partner-detail-hero-left">
							<p>{{sponsorsList?.title}}</p>
							<div class="our-partner-logo-left">
								<img [src]="sponsorsList?.image">
							</div>
						</div>
						<div class="our-partner-hero-right cf">
							<ngx-slick-carousel class="carousel" slickModal="slick-carousel"
								[config]="slideparterConfig">
								<div ngxSlickItem class="our-partner-logo slide" *ngFor="let sponsor of sponsorsList?.sponsors">
									<div class="our-partner-logo-inner">
										<img [src]="sponsor?.image">
									</div>
								</div>
							</ngx-slick-carousel>
						</div>
					</div>
				</div>
			</div>
		</div>
		<div class="join-register-section cf">
			<div class="container">
				<div class="join-register-detail cf">
					<div class="join-register-left">
						<h2>JOIN OUR MAILING LIST</h2>
						<p>Subscribe to our newsletters</p>
					</div>
					<div class="join-register-right forhome">
						<div class="signupform ">
							<div class="join-register-right-box">
								<div class="join-register-right-box-input half">
									<input class="register-style" placeholder="First Name" type="text">
								</div>
								<div class="join-register-right-box-input half">
									<input class="register-style" placeholder="Last Name" type="text">
								</div>
							</div>
							<div class="join-register-right-box">
								<div class="join-register-right-box-input">
									<input class="register-style" placeholder="Email Address" type="text">
								</div>
								<div class="join-register-right-box-input">
									<input class="register-style" placeholder="Mobile No" type="number">
								</div>
							</div>
							<div class="join-register-right-box">
								<div class="check-box">
									<label class="container">By submitting information you agree to our Terms of Use &
										Privacy Policy
										<input checked="checked" type="checkbox">
										<span class="checkmark"></span>
									</label>
								</div>
								<div class="join-register-btn"><button id="reg_button">Join Now</button></div>
							</div>
						</div>
					</div>
				</div>
			</div>
			<div class="join-register-overlay"></div>
		</div> -->
	</div>
</section><!-- page ends-->